import { render, staticRenderFns } from "./detail-drawer.vue?vue&type=template&id=6e6885c4&"
import script from "./detail-drawer.vue?vue&type=script&lang=js&"
export * from "./detail-drawer.vue?vue&type=script&lang=js&"
import style0 from "./detail-drawer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports